import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-challenge-action-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './challenge-action-button.component.html',
  styleUrl: './challenge-action-button.component.scss'
})
export class ChallengeActionButtonComponent {
  @Input() hasJoinedCompetition: boolean = false;
  @Input() hasSubmittedSolution: boolean = false;
  /** When true (API is_drafted), show "Resubmit Solution" even if hasSubmittedSolution is false. */
  @Input() isDrafted: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() isLoading: boolean = false;
  /** When true, evaluation end date has passed – show "Completed challenge" and disable. */
  @Input() isEvaluationPast: boolean = false;
  /** When true (e.g. challenge preview), show "Join Challenge" label and icon even when disabled. */
  @Input() previewMode: boolean = false;
  @Output() buttonClick = new EventEmitter<void>();

  onButtonClick(): void {
    if (!this.isDisabled && !this.isLoading) {
      this.buttonClick.emit();
    }
  }

  get buttonText(): string {
    if (this.isEvaluationPast || (this.isDisabled && !this.hasJoinedCompetition && !this.previewMode)) {
      return 'Completed challenge';
    }
    if (this.hasJoinedCompetition && !this.previewMode) {
      return this.hasSubmittedSolution || this.isDrafted ? 'Resubmit Solution' : 'Submit Solution';
    }
    if (this.previewMode && !this.hasJoinedCompetition) {
      return 'Join Challenge';
    }
    return 'Join Challenge';
  }

  get buttonClass(): string {
    if (this.previewMode && !this.hasJoinedCompetition) {
      return ''; // Join Challenge style (disabled visually via class from parent)
    }
    if (this.isEvaluationPast || (!this.hasJoinedCompetition && this.isDisabled)) {
      return 'challenge-action-button--completed';
    }
    if (this.hasJoinedCompetition && !this.hasSubmittedSolution && !this.isDrafted) {
      return 'challenge-action-button--submit';
    }
    return '';
  }

  /** In preview mode show Join Challenge icon; otherwise show checkmark when completed (evaluation past or disabled). */
  get showJoinIcon(): boolean {
    return !this.hasJoinedCompetition && (this.previewMode || (!this.isDisabled && !this.isEvaluationPast));
  }

  get showCompletedIcon(): boolean {
    return (this.isEvaluationPast || (!this.hasJoinedCompetition && this.isDisabled)) && !this.previewMode;
  }
}


